<template lang="html">
  <PageHeader />

  <section class="reset-password-email account-section mt-stickybar mb-5 home">
    <div class="account-banner text-center">
      <img src="@/assets/images/check-mail.png" alt="" />
    </div>
    <div class="container">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">
      <div class="card shadow-lg border-0 rounded-3 mt-5 bg-white">
        <div class="card-body p-4 text-center">
          <h2 class="mb-3">Reset Password Email</h2>
          <p class="mb-4">We have sent you an email. Check your inbox to reset your password.</p>

          <div class="mt-4">
            <button type="submit" class="btn btn-primary w-70 rounded-pill px-4 py-2" @click="backTologin">
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  </section>
  <PageFooter />
</template>

<script lang="js">

import { useRouter } from 'vue-router';
import SvgButton from '@/components/partials/SvgButton.vue';

export default {
  name: 'reset-password-email',
  props: [],
  components: {
    // SvgButton,
  },
  setup() {
    const router = useRouter();
    const backTologin = () => {
      router.push('/');
    };

    return { backTologin };
  },
};
</script>

<style scoped lang="scss"></style>
